import { useContext, useMemo } from "react";
import { AppContext } from "../../root/Root";
import { CreativeReviewContext } from "../../../contexts/contexts";
import { DefaultLayout } from "../../../layouts/DefaultLayout";
import Grid from "@mui/material/Unstable_Grid2";
import { CreativeAnalysis } from "../../../components/eRetail/creativeAnalysis/CreativeAnalysis";
import { PoolMetadata } from "../../../components/eRetail/poolMetadata/PoolMetadata";
import {
  DATA_SOURCE,
  DEFAULT_CREATIVE_REVIEW_CONTEXT,
} from "../../../constants";
import "../../../style/common.scss";

const metadataComponent = (props) => <PoolMetadata {...props} isReview />;

export const Level3DT = () => {
  useContext(AppContext);

  const contextValue = useMemo(
    () => ({
      metadataComponent,
    }),
    [],
  );

  return (
    <DefaultLayout>
      <Grid
        className="page-content"
        container
        rowSpacing={{ xs: 3, md: 0 }}
        columnSpacing={{ xs: 0, md: 2 }}
        padding={{ xs: 1, md: 2 }}
        disableEqualOverflow
      >
        <Grid xs={12}>
          <CreativeReviewContext.Provider
            value={{ ...DEFAULT_CREATIVE_REVIEW_CONTEXT, ...contextValue }}
          >
            <CreativeAnalysis dataSource={DATA_SOURCE.eRetail} />
          </CreativeReviewContext.Provider>
        </Grid>
      </Grid>
    </DefaultLayout>
  );
};
